import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import Slider from '../../components/Slider';
import MapSelect from '../../components/MapSelect/MapSelect';
import { FaWhatsapp } from 'react-icons/fa';

// const Img1 = 'https://cdn.nudus.app/Images/carrousel/6.png';
// const Img1mobile = 'https://cdn.nudus.app/Images/carrousel/mobile/6.png';

const Img1 = 'https://cdn.nudus.app/Images/carrousel/Productos%20importados%20(1).png';
const Img1mobile = 'https://cdn.nudus.app/Images/carrousel/Pisos%20de%20SPC.png';

const WhatsAppButton = () => {
  const handleClick = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'Link_whatsapp' });
  };

  return (
    <a
      href="https://wa.me/+5493535082532"
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      <div className="whatsapp-icon">
        <FaWhatsapp width={24} height={24} />
      </div>
      <span className="whatsapp-text">
        Chatea con nosotros<br />por WhatsApp
      </span>
      <style jsx>{`
        .whatsapp-button {
          display: flex;
          align-items: center;
          background-color: #ed1c24;
          color: white;
          margin: 0 auto;
          border-radius: 50px;
          padding: 10px 20px;
          font-weight: bold;
          font-size: 16px;
          cursor: pointer;
          text-decoration: none;
          transition: background-color 0.3s ease;
          width: fit-content;
        }
        .whatsapp-button:hover { background-color: #c00; }
        .whatsapp-icon {
          background-color: white;
          color: #ed1c24;
          border-radius: 50%;
          padding: 8px;
          margin-right: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .whatsapp-text {
          display: flex;
          flex-direction: column;
          line-height: 1.2;
        }
        .whatsapp-text br { display: none; }
        @media (min-width: 400px) {
          .whatsapp-text br { display: initial; }
        }
      `}</style>
    </a>
  );
};

const Landing = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    localidad: '',
    material: '',
    consumidor: '',
  });

  useEffect(() => {
    // Asegurarnos de que dataLayer exista
    window.dataLayer = window.dataLayer || [];
    const onResize = () => setIsMobile(window.innerWidth <= 500);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const validateForm = () => {
    const { name, email, phone, localidad, material, consumidor } = formData;
    if (!name || !email || !phone || !localidad || !material || !consumidor) {
      toast.error('Por favor completa todos los campos');
      return false;
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      toast.error('Por favor ingresa un correo electrónico válido');
      return false;
    }
    if (phone.length < 6 || isNaN(+phone)) {
      toast.error('Por favor ingresa un número de teléfono válido');
      return false;
    }
    return true;
  };

  const submitToGoogleForm = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      await fetch(
        'https://docs.google.com/forms/d/e/1FAIpQLSc4WCt1dVahfYsFi9gQn1K73oD6j8rDwA8gzjEUH4XDXsJvCQ/formResponse',
        {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            'entry.782456827': formData.name,
            'entry.1495591910': formData.email,
            'entry.910051675': formData.phone,
            'entry.858834568': formData.localidad,
            'entry.1478018999': formData.material,
            'entry.555546106': formData.consumidor,
          }).toString(),
        }
      );

      // Disparo GA4
      window.dataLayer.push({ event: 'Form_enviado' });

      toast.success('Formulario enviado correctamente');
      // opcional: limpiar formData
      setFormData({
        name: '',
        email: '',
        phone: '',
        localidad: '',
        material: '',
        consumidor: '',
      });
    } catch (err) {
      console.error(err);
      toast.error('Error al enviar el formulario');
    }
  };

  const url = isMobile ? Img1mobile : Img1;

  return (
    <>
      <div className="slider-container">
        <div className="slider-show-container">
          <div
            className="slider"
            style={{ backgroundImage: `url("${url}")` }}
          >
            <div className="first-slide-wrapper">
              <div className="first-slide-text">
                <h1>
                  COMERCIALIZAMOS<br />
                  MATERIALES PARA LA CONSTRUCCIÓN
                </h1>
                <p>
                  Formá parte de Lumadi: accedé a precios exclusivos, asesoramiento
                  personalizado y los mejores productos para tu negocio o proyecto
                  personal.
                </p>
                <WhatsAppButton />
              </div>

              {/* Form desktop */}
              {!isMobile && (
                <form
                  onSubmit={submitToGoogleForm}
                  className="first-slide-form desktop"
                >
                  <h3>COMPLETÁ EL FORMULARIO PARA QUE NUESTRO EQUIPO TE CONOZCA MEJOR</h3>
                  <input
                    type="text"
                    placeholder="Nombre completo"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                  />
                  <input
                    type="email"
                    placeholder="Correo electrónico"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                  <input
                    type="tel"
                    placeholder="Número de WhatsApp"
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData({ ...formData, phone: e.target.value })
                    }
                  />
                  <input
                    type="text"
                    placeholder="Localidad o provincia"
                    value={formData.localidad}
                    onChange={(e) =>
                      setFormData({ ...formData, localidad: e.target.value })
                    }
                  />

                  <select
                    value={formData.material}
                    onChange={(e) =>
                      setFormData({ ...formData, material: e.target.value })
                    }
                  >
                    <option value="" disabled>
                      ¿Qué tipo de productos te interesan?
                    </option>
                    <option>Wall panel interior y exterior - perfiles de WPC</option>
                    <option>Mármol de PVC</option>
                    <option>Revestimientos autoadhesivos</option>
                    <option>Cielorraso de PVC</option>
                    <option>Pisos flotantes de SPC</option>
                    <option>Deck de WPC</option>
                    <option>Césped sintético</option>
                    <option>Red de camuflaje</option>
                    <option>Melaminas, cantos y herrajes</option>
                    <option>Construcción en seco</option>
                    <option>Terciados fenolicos - puntales</option>
                    <option>Maderas en general</option>
                    <option>Autoelevadores Jac</option>
                    <option>Chapa de policarbonato</option>
                    <option>Otros</option>
                  </select>

                  <select
                    value={formData.consumidor}
                    onChange={(e) =>
                      setFormData({ ...formData, consumidor: e.target.value })
                    }
                  >
                    <option value="" disabled>
                      Tipo de cliente
                    </option>
                    <option>Consumidor final</option>
                    <option>Arquitecto/a</option>
                    <option>Decorador/a</option>
                    <option>Yesero</option>
                    <option>Constructora</option>
                    <option>Carpintero</option>
                    <option>Revendedor</option>
                  </select>

                  <button type="submit">DEJANOS TU CONSULTA</button>
                </form>
              )}
            </div>
          </div>
        </div>

        {/* Form mobile */}
        {isMobile && (
          <form onSubmit={submitToGoogleForm} className="first-slide-form mobile">
            <h3>COMPLETÁ EL FORMULARIO PARA QUE NUESTRO EQUIPO TE CONOZCA MEJOR</h3>
            <input
              type="text"
              placeholder="Nombre completo"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
            <input
              type="email"
              placeholder="Correo electrónico"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />
            <input
              type="tel"
              placeholder="Número de WhatsApp"
              value={formData.phone}
              onChange={(e) =>
                setFormData({ ...formData, phone: e.target.value })
              }
            />
            <input
              type="text"
              placeholder="Localidad o provincia"
              value={formData.localidad}
              onChange={(e) =>
                setFormData({ ...formData, localidad: e.target.value })
              }
            />

            <select
              value={formData.material}
              onChange={(e) =>
                setFormData({ ...formData, material: e.target.value })
              }
            >
              <option value="" disabled>
                ¿Qué tipo de productos te interesan?
              </option>
              {/* mismas opciones */}
            </select>

            <select
              value={formData.consumidor}
              onChange={(e) =>
                setFormData({ ...formData, consumidor: e.target.value })
              }
            >
              <option value="" disabled>
                Tipo de cliente
              </option>
              {/* mismas opciones */}
            </select>

            <button type="submit">DEJANOS TU CONSULTA</button>
          </form>
        )}
      </div>

      {/* Resto de la landing... */}
      <div className="slider-container-landing">
        <Slider showTitles={false} />
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '20px',
        }}
      >
        <p
          style={{
            fontWeight: 700,
            fontSize: '24px',
            color: '#ed1c24',
            textDecoration: 'underline',
          }}
        >
          Productos importados
        </p>
        <ul
          className="flex-wrapping"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '20px',
            listStyleType: 'none',
            padding: 0,
          }}
        >
          {/* enlaces a catálogos */}
        </ul>
      </div>

      <div className="experience-container">
        <div className="contact-container">
          <MapSelect />
          <div className="form-container">
            <div className="home-tittles">
              <h3 style={{ textAlign: 'left' }}>Contáctanos</h3>
              <hr style={{ marginLeft: 0 }} />
            </div>
            <div style={styles.container}>
              <div style={styles.contactItem}>
                <span style={styles.icon}>📞</span>
                <strong style={styles.bold}>Etruria</strong> 0353 5082532
              </div>
              <div style={styles.contactItem}>
                <span style={styles.icon}>✉️</span>
                <a
                  href="mailto:ventas@lumadimaderas.com.ar"
                  style={styles.link}
                >
                  ventas@lumadimaderas.com.ar
                </a>
              </div>
              <div style={styles.contactItem}>
                <span style={styles.icon}>📍</span>
                Av. Agustín Quaranta 1180, Etruria
                <br />
                San Martín 970, La Carlota
              </div>

              {/* WhatsApp footer */}
              <a
                href="https://wa.me/+5493535082532"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.whatsappButton}
                onClick={() => {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({ event: 'Link_whatsapp' });
                }}
              >
                Contactar por WhatsApp
              </a>

              <a
                href="mailto:ventas@lumadimaderas.com.ar"
                style={styles.emailButton}
              >
                Enviar Email
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const styles = {
  container: { margin: '0 auto' },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    marginBottom: '12px',
    color: '#333',
    lineHeight: 1.4,
  },
  icon: { fontSize: '18px', color: '#ed1c24', marginRight: '8px' },
  bold: { fontWeight: 600, marginRight: '4px' },
  link: { color: '#ed1c24', textDecoration: 'none' },
  whatsappButton: {
    width: '100%',
    backgroundColor: '#ed1c24',
    color: '#fff',
    padding: '12px',
    fontSize: '16px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    display: 'inline-block',
    textAlign: 'center',
    textDecoration: 'none',
    marginTop: '16px',
  },
  emailButton: {
    width: '100%',
    backgroundColor: '#fff',
    color: '#1c1c1c',
    padding: '12px',
    fontSize: '16px',
    fontWeight: 600,
    border: '1px solid #ccc',
    cursor: 'pointer',
    display: 'inline-block',
    textAlign: 'center',
    textDecoration: 'none',
    marginTop: '8px',
  },
};

export default Landing;
